import { setPointsForCriteriaInProgressInitState } from './InitState';
import CURSE_INSTANCE_ACTIONS from '../../../Actions/ActionTypes';
import { IAction } from '../../../../../__core/Interfaces/IAction';
import { ISetPointsForCriteriaInProgress } from '../Interfaces/ISetPointsForCriteriaInProgress';

export const setPointsForCriteriaInProgressReducer = (
  state: Array<ISetPointsForCriteriaInProgress> = setPointsForCriteriaInProgressInitState,
  action: IAction<ISetPointsForCriteriaInProgress>
): Array<ISetPointsForCriteriaInProgress> => {
  switch (action.type) {
    case CURSE_INSTANCE_ACTIONS.SET_POINTS_FOR_CRITERIA_START:
      return [...state, action.payload];

    case CURSE_INSTANCE_ACTIONS.SET_POINTS_FOR_CRITERIA_FINISH:
      return [
        ...state.filter(
          (value) =>
            value.criteriaId !== action.payload.criteriaId &&
            value.studentId !== action.payload.studentId
        ),
      ];

    default:
      return state;
  }
};
